var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('router-link',{staticClass:"py-2 w-full flex mr-2 px-4 items-center bg-white hover:shadow-md",attrs:{"to":{ path: _vm.report.path },"props":_vm.report.props}},[_c('font-awesome-icon',{attrs:{"icon":['far', _vm.icon]}}),_c('div',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.report.text))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }